import { Box, Typography } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import { ComponentProps } from 'react';
import { CustomBr, CustomLink } from './Components';

type MarkdownPreviewProps = {
    description?: string;
    markdownStyles: any;
    onCheckboxChange?: (str: string, index: number) => void;
} & ComponentProps<typeof MDEditor.Markdown>

const MarkdownPreview = ({
    description,
    markdownStyles,
    onCheckboxChange,
    ...props
}: MarkdownPreviewProps) => {
    const getCheckboxIndex = (element: HTMLElement): number => {
        const container = element.closest('.wmde-markdown');
        if (!container) return 0;
        const allCheckboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'));
        return allCheckboxes.indexOf(element as HTMLInputElement);
    };

    if (!description) {
        return <Box
            sx={markdownStyles}
        >
            <Typography color="text.secondary" variant="subtitle2" gutterBottom>-</Typography>
        </Box>;
    }

    return (
        <Box
            p={1}
            border={'1px solid'}
            borderColor="divider"
            borderRadius={1}
            sx={markdownStyles}
        >
            <MDEditor.Markdown
                source={description}
                components={{
                    p: ({ children }) => {
                        return <p style={{ whiteSpace: 'pre-line' }}>{children}</p>;
                    },
                    input: ({ checked, node, ...props }) => {
                        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                            const element = e.target;
                            const index = getCheckboxIndex(element);
                            onCheckboxChange?.(description || '', index);
                        };

                        return (
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={handleChange}
                            />
                        );
                    },
                    br: () => <CustomBr />,
                    a: (props) => <CustomLink {...props} />,
                }}
                {...props}
            />
        </Box>
    );
};

export default MarkdownPreview;